import { api } from '../../lib/api';
import type { AuditListResponse } from './types';

export interface AuditFilters {
  actorEmail?: string;
  targetType?: string;
  targetId?: string;
  action?: string;
  from?: string;
  to?: string;
  cursor?: string | null;
  limit?: number;
}

function qs(filters: AuditFilters): string {
  const p = new URLSearchParams();
  if (filters.actorEmail) p.set('actorEmail', filters.actorEmail);
  if (filters.targetType) p.set('targetType', filters.targetType);
  if (filters.targetId) p.set('targetId', filters.targetId);
  if (filters.action) p.set('action', filters.action);
  if (filters.from) p.set('from', filters.from);
  if (filters.to) p.set('to', filters.to);
  if (filters.cursor) p.set('cursor', filters.cursor);
  if (filters.limit) p.set('limit', String(filters.limit));
  const s = p.toString();
  return s ? `?${s}` : '';
}

export function fetchAudit(filters: AuditFilters = {}): Promise<AuditListResponse> {
  return api.get<AuditListResponse>(`/admin/audit${qs(filters)}`);
}
